import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CustomValidator} from '@app/helpers/validators';
import {MunicipalityModel} from '@app/models/market-supplier/supplier-request.model';
import {initProvinces} from '@app/marketplace/locations/locations';
import {AddContactEvent, ContactOutputInterface, PushContactModel, PutContactModel} from '@app/marketplace/checkout/_models/contact.model';
import {TreeviewItem} from 'ngx-treeview';
import {Store} from '@ngrx/store';
import * as fromContactActions from '../../state/contacts/contacts-actions';

@Component({
  selector: 'app-add-contact',
  templateUrl: './add-contact.component.html',
  styleUrls: ['./add-contact.component.css']
})
export class AddContactComponent implements OnInit {

  @Input() contact: ContactOutputInterface;
  @Input() location: number;
  @Output() showForm = new EventEmitter<AddContactEvent>();
  contactForm: FormGroup;
  item: MunicipalityModel;
  locations = initProvinces;
  onSaveEvent = false;

  constructor(private store: Store<any>) {
  }

  ngOnInit(): void {
    this.item = this.contact ? {text: '', code: this.contact.municipality} : {text: '', code: this.location || 0};
    this.loadForm();
  }

  loadForm() {
    this.contactForm = new FormGroup({
      firstName: new FormControl(this.contact?.firstName || '', Validators.required),
      lastName: new FormControl(this.contact?.lastName || '', Validators.required),
      secondLastName: new FormControl(this.contact?.secondLastName || ''),
      identity: new FormControl(this.contact?.identity || '', [Validators.required, CustomValidator.identity, CustomValidator.onlyInt]),
      phone: new FormControl(this.contact?.phone || '', [Validators.required, CustomValidator.phoneValidator]),
      addressLine1: new FormControl(this.contact?.address?.addressLine1 || '', Validators.required),
      location: new FormControl(this.contact?.municipality || this.location || '', Validators.required),
      note: new FormControl(this.contact?.note || ''),
      email: new FormControl(this.contact?.email || ''),
      addressLine2: new FormControl(this.contact?.address?.addressLine2 || ''),
      zipCode: new FormControl(this.contact?.address?.zipCode || ''),
      isDefault: new FormControl(this.contact?.isDefault == true || this.contact?.isDefault == false ? this.contact?.isDefault : true),
      town: new FormControl(this.contact?.town || '')
    });
  }

  saveContact() {
    this.onSaveEvent = true;
    if (this.contactForm.invalid) {
      return;
    }
    const event: AddContactEvent = {showForm: false, contact: null, action: ''};

    if (!this.contact) {
      const row = new PushContactModel(this.contactForm.getRawValue());
      event.contact = row;
      event.action = 'add';
    } else {
      const row = new PutContactModel(this.contactForm.getRawValue());
      row.code = this.contact.code;
      event.contact = row;
      event.action = 'update';
    }
    this.showForm.emit(event);
  }

  onChange($event, location = true) {
    if (location) {
      this.contactForm.controls['location'].setValue(this.item.code);
      if (!this.contactForm.dirty) {
        this.contactForm.markAsDirty();
      }
    }
    document.body.click();
  }

}
